import React from 'react';
import {ClinicObjectSlimWithCapacity, Location} from 'src/services/api/types/types';
import {ClinicListItem} from './ClinicListItem';
import {LocationListItem} from './LocationListItem';
import './ListItem.scss';

interface ListItemProps {
    location?: Location;
    clinic?: ClinicObjectSlimWithCapacity;
    reasonParams: Array<string>;
    distance?: {value: number; unit: string};
}

function ListItemComponent({location, clinic, reasonParams, distance}: ListItemProps) {
    if (clinic) {
        return <ClinicListItem clinic={clinic} reasonParams={reasonParams} distanceToClinic={distance} />;
    }
    if (location) {
        return <LocationListItem location={location} reasonParams={reasonParams} distanceToLocation={distance} />;
    }

    return <></>;
}

export const ListItem = React.memo(ListItemComponent);
